export const intraBankTransfer = {
    "circular": [
        {
            "idPair": [
                // 164,
                // 165
            ],
            "accountPair": [
                // "YESBIN - 02202 - Current",
                // "YESBIN - 03563 - Current"
            ],
            "intraBankFundTransfer": [
                {
                    "date": "",
                    "amount": "",
                    "accountType": "CA",
                    "bankAccountId": "",
                    "pairCount": "",
                    "particulars": "",
                    "type": "DB"
                },
                // {
                //     "date": "2023-09-04",
                //     "amount": 5.0,
                //     "accountType": "CA",
                //     "bankAccountId": 165,
                //     "pairCount": 0,
                //     "particulars": "FUNDS TRF FROM XX2202/UNIQUETEXTILE ",
                //     "type": "CR"
                // },
                // {
                //     "date": "2023-09-04",
                //     "amount": 39000.0,
                //     "accountType": "CA",
                //     "bankAccountId": 164,
                //     "pairCount": 1,
                //     "particulars": "FUNDS TRF TO XX3563/NA/UNIQUETEXTILE ",
                //     "type": "DB"
                // },
                // {
                //     "date": "2023-09-04",
                //     "amount": 39000.0,
                //     "accountType": "CA",
                //     "bankAccountId": 165,
                //     "pairCount": 1,
                //     "particulars": "FUNDS TRF FROM XX2202/UNIQUETEXTILE ",
                //     "type": "CR"
                // },
                // {
                //     "date": "2023-09-04",
                //     "amount": 300010.0,
                //     "accountType": "CA",
                //     "bankAccountId": 164,
                //     "pairCount": 2,
                //     "particulars": "FUNDS TRF TO XX3563/NA/UNIQUETEXTILE ",
                //     "type": "DB"
                // },
                // {
                //     "date": "2023-09-04",
                //     "amount": 300010.0,
                //     "accountType": "CA",
                //     "bankAccountId": 165,
                //     "pairCount": 2,
                //     "particulars": "FUNDS TRF FROM XX2202/UNIQUETEXTILE ",
                //     "type": "CR"
                // }
            ]
        }
    ]
}